import type { Widen } from './catalogue';
import { enAuth } from './en/auth';
import { enMedia } from './en/media';
import { enProjects } from './en/projects';
import { enSettings } from './en/settings';
import { enShell } from './en/shell';
import type { sv } from './sv';

// The English catalogue (OQ-162): the same keys as sv.ts.
export const en: Widen<typeof sv> = {
  common: {
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    loading: 'Loading…',
    yes: 'Yes',
    no: 'No',
    on: 'On',
    off: 'Off',
    passwordTooWeak: 'Password is too weak (at least {{min}} characters)',
    passwordHint: 'At least {{min}} characters.',
    showPassword: 'Show password',
    hidePassword: 'Hide password'
  },
  language: {
    label: 'Language',
    sv: 'Svenska',
    en: 'English',
    saveFailed: 'Could not save the language.'
  },
  shell: enShell,
  media: enMedia,
  auth: enAuth,
  settings: enSettings,
  projects: enProjects
};
